<div class="capa-home">
  <h1 class="titulo">Departamentos y áreas de atención</h1>

  <mat-accordion #acordeon="matAccordion">
    <!-- <mat-expansion-panel *ngFor="let oDto of aDatos; let i = index;" [expanded]="i === 0" (opened)="panelOpenState = true" -->
    <mat-expansion-panel
      *ngFor="let oDto of aDatos; let i = index"
      (opened)="panelOpenState = true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="area-titulo">
          {{ oDto.DEPARTAMENTO }}
        </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="caja-info1">
        <p><b>Horario de atención:</b></p>
        <ul class="lista-horarios">
          <li *ngFor="let sHorario of oDto.HORARIO">{{ sHorario }}</li>
        </ul>

        <p><b>Áreas de atención</b></p>
        <div class="caja-info2" *ngFor="let oArea of oDto.AREAS">
          <p class="titulo-area">{{ oArea.AREA }}</p>
          <p [innerHTML]="oArea.INFO"></p>
          <p class="mensaje">{{ oArea.CARENCIA }}</p>
          <app-info-tramites-area
            [idAreaActiva]="oArea.id_area"
          ></app-info-tramites-area>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
